import cn from '@/lib/cs';
import React from 'react';

const AchievementIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M22.3 10.3Zm-3.2-4.9c2.6 1.8 3.1 4.4 3.2 5l-1.7.8-1.2.6-1.4 1.7V15L17 17l.3 2.1 1 2.2c-.4.4-4 3.4-9 2.5-4.8-.8-7.2-4.7-7.5-5.2l1-1 1.4-2 .6-2-.3-2.9-.2-.3-.4-1-1.9-2.9C2.2 6.1 4.5 3 8.3 3c1.6 0 3 .5 3.6.9l.8-3.9 1.9.2-.7 4c.6 0 3-.3 5.2 1.2Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default AchievementIcon;
